export default function isBuilderEditingMode(url: URL) {
  return hasUrlParam('savvy_editing', undefined, url)
}

function hasUrlParam(key: string, value: string | undefined, url: URL) {
  const urlParams = new URLSearchParams(url.search)
  return value === undefined
    ? ![undefined, null, false, 'false'].includes(urlParams.get(key))
    : urlParams.get(key) === value
}
